/*
 * Public API Surface of privacy-policy
 */

export * from './lib/privacy-policy.service';
export * from './lib/privacy-policy/privacy-policy.component';
export * from './lib/privacy-policy.module';
